/*
    Бегущая строка
*/

let marqs;
let smController;
let textLine;


export class Marquee {
    constructor(el) {
        this.$container = $(el);
        this.$inner = this.$container.find('.js-marquee-inner');
        this.duplicateText();
        this.calculateSpeed();
        this.initAppear();
    }


    calculateSpeed() {
        /*
            Меняем скорость анимации в зависимости от количества текста
            и размера шрифта, чтобы скорость движения всегда была
            примерно одинаковая
        */

        const len = this.$inner.data('text').length;
        let coef = 0.8; // коэффициент ускорения

        if (this.$container.is('.marquee--title-1')) {
            coef = 1.4;
        }

        this.$inner.children().css({
            'animation-duration': `${len * coef}s`
        });
    }


    duplicateText() {
        /*
            Множим текст, чтобы сделать реже мелькания,
            которые возникают при замыкании цикла анимации
        */
        let text = this.$inner.data('text');
        
        if (!text) {
            this.$inner.parent().hide();
        } else {
            // if (App.H.is('.ios.safari') && (text.length > 80)) {
            //     text = text ? ` — ${text}\u00A0` : ``;
            // } else {
            //     text = text ? ` — ${text} — ${text}\u00A0` : ``;
            // }

            text = text ? ` — ${text}\u00A0` : ``;

            this.$inner
            // .attr('data-new-text', text)
            .children()
            .text(text);
        }
    }


    initAppear() {
        /*
            Появляется только когда блок в центре экрана
        */
        if (!this.$container.is('.js-marquee-appear')) { return; }

        new ScrollMagic.Scene({ triggerElement: this.$container[0] })
            .setClassToggle(this.$container[0], '_visible')
            .addTo(smController);
    }
}



App.W.on('barba:afterEnter', () => {
    marqs = [];
    textLine = [];
    smController = new ScrollMagic.Controller({
        globalSceneOptions: {
            duration: 450,
            offset: -250
        }
    });

    /*
        В этот момент существует два контейнера .js-barba-container,
        поэтому надо делать какую-то выборку
    */
        const len = [];
    App.H.find('.js-barba-container .js-marquee-block').each((i, el) => {
        // marqs[i] = new Marquee(el);
        
        // подключили сторонний скрипт для непрерывной бегущей строки
        textLine[i] = $(el).find($('.js-marquee-inner'));
        len[i] = textLine[i].data('text').length;
        let coef = 0.8; // коэффициент ускорения
        if ($(el).is('.marquee--title-1')) {
            coef = 1.4;
        }
        $(el).find($('.js-marquee-inner')).marquee({
            duration: len[i] * coef * 1000,
            gap: 20,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            startVisible: true
        });

        if ($(el).hasClass('js-marquee-appear')) { 
            new ScrollMagic.Scene({ triggerElement: $(el)[0] })
                .setClassToggle($(el)[0], '_visible')
                .addTo(smController);
        }
    });
});


App.W.on('barba:leave', () => {
    try {
        smController = smController.destroy(true);
    } catch (error) { }

    /*$.each(marqs, function() {
        try {
            this.destroy();
        } catch (error) {
            console.log(error);
        }
    });*/
});



// WEBPACK FOOTER //
// ./_src/js/modules/Marquee.js